import React, { useEffect, useCallback, useState } from "react";

import {
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";

import ThreeSlotWorking from "./components/ThreeSlotWorking";
import ThreeSlotHeroBanner from "./components/ThreeSlotHeroBanner";

import { CommonBreadcrumbs } from "../../../Components/ui";
import { Path } from "../../../../static/Constants";
import { THREE_SLOT_CONFIG } from "./components/threeSlotConfig";
import { colors, borderRadiusPx } from "../../../../theme";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useHistory } from "react-router-dom";

import NavBar from "../../../Components/NavBar";

import {
  getConnectedAccount,
  connectWallet as triggerConnectWallet,
  subscribeToWalletEvents,
} from "../../../../static/walletUtils";

// import slotInstance from "../../../Service/slotInstance";
// import web3 from "../../../Service/web3";

// colors imported above

import ThreeSlotMachineCard from "./components/ThreeSlotMachineCard";

import "./ThreeSlotLottery.css";

// Dummy data needs to be removed after proper mapping with contract.
export const DUMMY_LOTTERIES = [
  {
    lotteryId: 101,
    name: "3-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "1364.22",
        seedValue: "1000.00",
        contributionPerSpin: "0.020",
      },
      major: {
        amount: "8945.76",
        seedValue: "5000.00",
        contributionPerSpin: "0.008",
      },
      mega: {
        amount: "54228.41",
        seedValue: "20000.00",
        contributionPerSpin: "0.002",
      },
    },
  },

  {
    lotteryId: 102,
    name: "3-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "820.50",
        seedValue: "500.00",
        contributionPerSpin: "0.020",
      },
      major: {
        amount: "4250.00",
        seedValue: "2500.00",
        contributionPerSpin: "0.008",
      },
      mega: {
        amount: "25100.75",
        seedValue: "10000.00",
        contributionPerSpin: "0.002",
      },
    },
  },

  {
    lotteryId: 103,
    name: "3-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "450.25",
        seedValue: "250.00",
        contributionPerSpin: "0.020",
      },
      major: {
        amount: "2100.40",
        seedValue: "1000.00",
        contributionPerSpin: "0.008",
      },
      mega: {
        amount: "12500.00",
        seedValue: "5000.00",
        contributionPerSpin: "0.002",
      },
    },
  },

  {
    lotteryId: 104,
    name: "3-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "2450.80",
        seedValue: "1500.00",
        contributionPerSpin: "0.020",
      },
      major: {
        amount: "12500.60",
        seedValue: "7500.00",
        contributionPerSpin: "0.008",
      },
      mega: {
        amount: "78500.00",
        seedValue: "30000.00",
        contributionPerSpin: "0.002",
      },
    },
  },

  {
    lotteryId: 105,
    name: "3-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "180.10",
        seedValue: "100.00",
        contributionPerSpin: "0.020",
      },
      major: {
        amount: "950.50",
        seedValue: "500.00",
        contributionPerSpin: "0.008",
      },
      mega: {
        amount: "5200.00",
        seedValue: "2500.00",
        contributionPerSpin: "0.002",
      },
    },
  },

  {
    lotteryId: 106,
    name: "3-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "3200.45",
        seedValue: "2000.00",
        contributionPerSpin: "0.020",
      },
      major: {
        amount: "18500.30",
        seedValue: "10000.00",
        contributionPerSpin: "0.008",
      },
      mega: {
        amount: "95000.00",
        seedValue: "40000.00",
        contributionPerSpin: "0.002",
      },
    },
  },

  {
    lotteryId: 107,
    name: "3-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "1100.75",
        seedValue: "750.00",
        contributionPerSpin: "0.020",
      },
      major: {
        amount: "6800.25",
        seedValue: "3500.00",
        contributionPerSpin: "0.008",
      },
      mega: {
        amount: "36500.50",
        seedValue: "15000.00",
        contributionPerSpin: "0.002",
      },
    },
  },
];

const SlotLottery = () => {
  const history = useHistory();

  const [account, setAccount] = useState("");
  const [lotteries, setLotteries] = useState(DUMMY_LOTTERIES);

  const fetchSlotGames = useCallback(async () => {
    /*
    try {
      if (!slotInstance?.methods?.gameId || !slotInstance?.methods?.slotGames) return;
      const totalGames = await slotInstance.methods.gameId().call();
      const count = Number(totalGames);
      if (count <= 0) return;

      const loadedGames = [];
      for (let i = 1; i <= count; i++) {
        try {
          const game = await slotInstance.methods.slotGames(i).call();
          if (game && (String(game.reels) === "3" || Number(game.reels) === 3)) {
            const minBetFormatted = web3?.utils?.fromWei ? web3.utils.fromWei(String(game.minBet || "0"), "ether") : "1.00";
            const maxBetFormatted = web3?.utils?.fromWei ? web3.utils.fromWei(String(game.maxBet || "0"), "ether") : "100.00";
            const numericMax = parseFloat(maxBetFormatted) || 100;
            const numericMin = parseFloat(minBetFormatted) || 1;

            loadedGames.push({
              lotteryId: Number(game.gameId || i),
              name: `3-SlotBET #${game.gameId || i}`,
              creator: game.owner ? `${game.owner.slice(0, 6)}...${game.owner.slice(-4)}` : "AutoBET Creator",
              owner: game.owner,
              active: game.active,
              minBet: minBetFormatted,
              maxBet: maxBetFormatted,
              jackpots: {
                mini: {
                  amount: (numericMax * 0.15).toFixed(2),
                  seedValue: (numericMax * 0.1).toFixed(2),
                  contributionPerSpin: (numericMin * 0.02).toFixed(3),
                },
                major: {
                  amount: (numericMax * 0.45).toFixed(2),
                  seedValue: (numericMax * 0.3).toFixed(2),
                  contributionPerSpin: (numericMin * 0.008).toFixed(3),
                },
                mega: {
                  amount: (numericMax * 1.2).toFixed(2),
                  seedValue: (numericMax * 0.6).toFixed(2),
                  contributionPerSpin: (numericMin * 0.002).toFixed(3),
                },
              },
            });
          }
        } catch (itemErr) {
          console.warn(`Error loading slot game ${i}:`, itemErr);
        }
      }

      if (loadedGames.length > 0) {
        setLotteries([...loadedGames, ...DUMMY_LOTTERIES]);
      }
    } catch (err) {
      console.warn("Could not fetch slot games from slotInstance:", err);
    }
    */
  }, []);

  const combinedPrize = lotteries.reduce((acc, lottery) => {
    return (
      acc +
      parseFloat(lottery.jackpots.mini.amount) +
      parseFloat(lottery.jackpots.major.amount) +
      parseFloat(lottery.jackpots.mega.amount)
    );
  }, 0).toFixed(2);

  const checkAccount = useCallback(async () => {
    const acc = await getConnectedAccount();
    setAccount(acc);
  }, []);

  const connectWallet = async () => {
    const res = await triggerConnectWallet();

    if (res.account) {
      setAccount(res.account);
    } else if (res.error === "NO_WALLET") {
      toast.error(res.message);
    } else if (res.isPending) {
      toast.info(res.message);
    } else if (!res.isCancelled && res.message) {
      toast.error(res.message);
    }
  };

  const handleOpenLottery = (lotteryId) => {
    history.push(`/three-slotlottery/${lotteryId}`);
  };

  useEffect(() => {
    checkAccount();
    fetchSlotGames();

    const unsubscribe = subscribeToWalletEvents({
      onAccountsChanged: (acc) => {
        setAccount(acc);
        fetchSlotGames();
      },
      onDisconnect: () => setAccount(""),
    });

    return unsubscribe;
  }, [checkAccount, fetchSlotGames]);

  return (
    <Box
      sx={{
        position: "relative",
        overflowX: "hidden",
        minHeight: "100vh",
        bgcolor: colors.dashboard.canvas,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={3000}
        theme="colored"
      />

      <NavBar />

      <Container
        maxWidth="xl"
        className="slot-page-container"
        sx={{
          pt: { xs: "96px", sm: "108px", md: "116px" },
          pb: 8,
          flexGrow: 1,
        }}
      >
        <Box sx={{ mb: 4 }}>
          <CommonBreadcrumbs
            items={[
              { label: "Home", path: Path.root },
              { label: "All Lotteries", path: Path.allLotteries },
              { label: `${THREE_SLOT_CONFIG.name}` },
            ]}
          />
        </Box>

        <ThreeSlotHeroBanner
          totalActive={lotteries.length}
          combinedPrize={combinedPrize}
        />

        <Grid container spacing={3} alignItems="flex-start">
          {lotteries.map((lottery) => (
            <Grid item xs={12} sm={6} lg={4} key={lottery.lotteryId}>
              <Box
                onClick={() => handleOpenLottery(lottery.lotteryId)}
                sx={{
                  cursor: "pointer",
                }}
              >
                <ThreeSlotMachineCard
                  lotteryData={lottery}
                  account={account}
                  onConnectWallet={connectWallet}
                />
              </Box>
            </Grid>
          ))}
        </Grid>

        <ThreeSlotWorking />
      </Container>
    </Box>
  );
};

export default SlotLottery;